<div class="flex w-full flex-col items-center justify-center gap-2 lg:w-fit lg:py-5">
  <div class="flex w-full flex-col items-center justify-between gap-2 lg:min-w-72 lg:max-w-72">
    @for (item of visibleRows(); track item.key) {
      <div class="border-proffeo-border flex w-full items-center justify-between gap-3 border-b-2 px-4 py-2">
        <p class="text-proffeo-text text-base">{{ item.label | translate }}:</p>
        <p class="text-proffeo-text text-base">
          {{ item.isoDuration | intlDuration }}
        </p>
      </div>
    }
  </div>
</div>
